<template>
     <div class="container-fluid">
         <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class="header-title">
                            <h4 class="card-title">Add Announcement</h4>
                        </div>
                    </div>
                    <div class="card-body">
                        <form>
                            <div class="form-group mb-3 pb-1">
                                <label for="title"><bold class="asterik">* </bold>Title:</label>
                                <b-form-input type="text" id="title" placeholder="Title" :class="`form-control ${$v.announcementForm.title.$error ? 'is-invalid' : ''}`"
                                    v-model="announcementForm.title" @input="$v.announcementForm.title.$touch()" @blur="$v.announcementForm.title.$touch()" required>
                                </b-form-input>
                                <div class="invalid-feedback"><small>Required field</small></div>
                            </div>

                             <div class="form-group group mb-3 pb-1">
                                <label for="subTitle">Sub Title:    (Optional)</label>
                                <b-form-input style="width: 70%;" type="text" id="subTitle" placeholder="Name" :class="`form-control`"
                                    v-model="announcementForm.subTitle" @input="$v.announcementForm.subTitle.$touch()" @blur="$v.announcementForm.subTitle.$touch()">
                                </b-form-input>
                            </div>

                            <div class="form-group mb-3 pb-1">
                                <label for="message"><bold class="asterik">* </bold>Announcement</label>
                                <b-form-textarea id="message" placeholder="Announcement Message" size="lg" :class="`form-control ${$v.announcementForm.message.$error ? 'is-invalid' : ''}`"
                                    v-model="announcementForm.message" @input="$v.announcementForm.message.$touch()" @blur="$v.announcementForm.message.$touch()" required>
                                </b-form-textarea>
                                <div class="invalid-feedback"><small>Required field</small></div>
                            </div>     

                            <div class="form-group group mb-3 pb-1">
                                <label for="active"><bold class="asterik">* </bold>Active Status</label>
                                <section :class="` ${$v.announcementForm.active.$error ? 'is-invalid' : ''}`">
                                    <input type="radio" v-model="announcementForm.active" value="1"> Active
                                    <input type="radio" v-model="announcementForm.active" value="0"> Inactive
                                </section>
                                <div class="invalid-feedback"><small>Required field</small></div>
                            </div>                        
                        </form>

                        <div class="col-md-12 form-group">
                            <button type="button" class="btn btn-primary float-right" v-on:click="register">Add</button>
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const config = require("../../../../../config");
// const constants = require("../../../../constants/CommonConstants");

Vue.use(VueAxios, axios)

export default {
    name:'Announcement',

    data() {
        return {
             announcementForm: {
                subTitle: '',
                title:'',
                message: '',
                active:'',
                createdBy:'',
                createdDate:''
            },
        }
    },

    mixins: [validationMixin],
    validations: {
        announcementForm: {  
            title: { required },
            message: { required },
            active: {required}   
        }
    },

    methods: {
        register: async function() {
            try {
                this.$v.$touch();
                var user = JSON.parse(localStorage.getItem("user"));
        
                if(!this.$v.$invalid && confirm("Are you sure you want to save this announcement?")) {
                    this.announcementForm.createdBy = user.username
                    await axios.post(config.api.URL + '/api/announcement/add', this.announcementForm, { params: { m: this.$route.meta.uid } });
                
                    alert("Announcement is added successfully.");
                   this.$router.push({path: '/announcement/list'});
                }
            } catch(error) {
                alert("Error!")
                console.log("error", error)
            }
        },
    }
}
</script>